import styled from '@emotion/styled';

const TextContainer = styled.div`
  display: flex;
  margin-left: 15px;
  align-items: left;
  flex-direction: column;
  justify-content: center;
`;

export default TextContainer;
